const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9e1dd3064674cf14a3ea322b74ee5ec4d6ad8884"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gb-savings-acct@little-bit-pte-ltd"]={id:"9e1dd3064674cf14a3ea322b74ee5ec4d6ad8884"};
      